import Component_PauseRenderer_9ec1ffc8fbe052a83d3f21e482ee6b0a from "../../../../content/examples/basic/pause-renderer/PauseRenderer";
import Devtool_PauseRenderer_9ec1ffc8fbe052a83d3f21e482ee6b0a from "!!@devtool/loader!../../../../content/examples/basic/pause-renderer/PauseRenderer";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_PauseRenderer_9ec1ffc8fbe052a83d3f21e482ee6b0a,
  Devtool_PauseRenderer_9ec1ffc8fbe052a83d3f21e482ee6b0a,
  DevTool,
  React
};